import { render, staticRenderFns } from "./declaration.vue?vue&type=template&id=4c1a6dfc&scoped=true"
import script from "./declaration.vue?vue&type=script&lang=ts"
export * from "./declaration.vue?vue&type=script&lang=ts"
import style0 from "./declaration.vue?vue&type=style&index=0&id=4c1a6dfc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1a6dfc",
  null
  
)

export default component.exports